/**
 * Slots in the app chrome that a feature fills without the chrome importing
 * the feature.
 *
 * `components/core/` may not depend on `components/features/` (the layering
 * rule in `.eslintrc.cjs`), yet the Navbar has to show the running focus
 * timer. So the Navbar renders whatever node sits in `navbarAccessory`, and
 * `app/provider.tsx` - which may import features - puts the timer there.
 * Empty by default, so a bare Navbar renders exactly as before.
 */
import { createContext, useContext, type ReactNode } from 'react';

export interface ShellSlots {
  /** Beside the profile on desktop, beside the menu button on mobile. */
  navbarAccessory?: ReactNode;
}

const ShellSlotsContext = createContext<ShellSlots>({});

export function ShellSlotsProvider({
  children,
  ...slots
}: ShellSlots & { children: ReactNode }) {
  return (
    <ShellSlotsContext.Provider value={slots}>
      {children}
    </ShellSlotsContext.Provider>
  );
}

export function useShellSlots(): ShellSlots {
  return useContext(ShellSlotsContext);
}
